import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeBrackets: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="code-brackets">
      <path
        d="M10 20L14 4M18 8.00004L22 12L18 16M6 16L2 12L6 8.00004"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconCodeBrackets;
